export const GET_PROVINCES = `
  query getProvinces($tenant_id: Int!) {
    getProvinces(tenant_id: $tenant_id) {
      id
      name
      active
      interior
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
    }
  }
`;
